import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  DELETE,
} from 'admin-on-rest';
import { restClient } from '../../App';
import { randomize } from '../../utils/StringUtils';
import firestore from '../../config/firestore-init';

const FILES = 'files';
const DIRECTORIES = 'directories';
const USERS_COLLECTION = 'users';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';

const uploadDocument = (file, title, meta = {}) => {
  const key = randomize.separatedNumbers();
  const body = new FormData();
  body.append('file', file);
  body.append('key', key);
  body.append('title', title);
  body.append('meta', JSON.stringify({ ...meta, key }));
  body.append('resource', 'documents');
  return fetch(`${API_BASE_URL}/utils/upload-file`, {
    method: 'POST',
    credentials: 'include',
    body,
  }).then((res) => res.json());
};

export const createFolder = async (folder) => restClient(CREATE, DIRECTORIES, {
  data: folder,
});

export const updateFolder = async ({ id, ...data }) => restClient(UPDATE, DIRECTORIES, {
  id,
  data,
});

export const createFile = async (formData) => {
  const data = await afterFileUploading(formData);
  return restClient(CREATE, FILES, {
    data,
  });
};

export const updateFile = async ({ id, ...formData }) => {
  const data = await afterFileUploading(formData);
  return restClient(UPDATE, FILES, {
    id,
    data,
  });
};

export const afterFileUploading = async ({ files, ...data }) => {
  const hasPreviousUploadedFile = !!(data.fileSrc);
  const hasFileToBeUploaded = files && files[0] && files[0].rawFile;
  const hasLinkProvided = data.link;
  if (!hasPreviousUploadedFile && !hasFileToBeUploaded && !hasLinkProvided) {
    throw new Error('No actual file or link found...');
  }
  if (data.hasExternalLink) {
    return {
      ...data,
      fileSrc: '',
      fileTitle: '',
      fileSize: '',
    };
  }
  if (hasFileToBeUploaded) {
    const [{
      rawFile, title,
    }] = files;
    const { fileUrl, title: fileName } = await uploadDocument(rawFile, title);
    return {
      ...data,
      fileSrc: fileUrl,
      fileTitle: fileName,
      link: '',
    };
  }

  return data;
};

export const getOneFolder = async (id) => {
  const { data } = await restClient(GET_ONE, DIRECTORIES, { id });
  return data;
};

export const removeFolder = async (id) => restClient(DELETE, DIRECTORIES, { id });
export const removeFile = async (id) => restClient(DELETE, FILES, { id });

export const getFolders = async (parentId) => {
  const MAX_FOLDER_COUNT = 200;
  const filter = { parent: parentId || null };
  const { data } = await restClient(GET_LIST, DIRECTORIES, {
    pagination: { page: 1, perPage: MAX_FOLDER_COUNT },
    sort: { field: 'id', order: 'DESC' },
    filter,
  });
  return data;
};

export const getFiles = async (parentId) => {
  const MAX_FILE_COUNT = 200;
  const filter = { parent: parentId || null };
  const { data } = await restClient(GET_LIST, FILES, {
    pagination: { page: 1, perPage: MAX_FILE_COUNT },
    sort: { field: 'id', order: 'DESC' },
    filter,
  });
  return data;
};

export const getFolderContent = async (parentId) => {
  const folders = await getFolders(parentId);
  const files = await getFiles(parentId);
  return {
    folders,
    files,
  };
};

export const fetchAllUsers = async () => {
  const snapShot = await firestore.collection(USERS_COLLECTION).get();
  return snapShot
    .docs
    .map((u) => u.data())
    .filter(({ fullName, venues, superUser }) => {
      const hasVenues = venues && venues.length > 0;
      return (hasVenues || superUser) && fullName;
    });
};
